exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Vj5gVVyoPZcdkg_KtpOcF{word-break:break-word}", ""]);
// Exports
exports.locals = {
	"messageBody": "Vj5gVVyoPZcdkg_KtpOcF"
};